import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  Box,
  VStack,
  HStack,
  Heading,
  useColorModeValue,
} from '@chakra-ui/react';

const ConfirmationModal = ({ isOpen, onClose, onConfirm, message }) => {
  // Color mode values for modern styling
  const cardBg = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.600');
  const textColor = useColorModeValue('gray.700', 'gray.200');
  const subtleTextColor = useColorModeValue('gray.600', 'gray.400');
  const shadowColor = useColorModeValue('rgba(0, 0, 0, 0.1)', 'rgba(0, 0, 0, 0.3)');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered>
      <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
      <ModalContent
        bg={cardBg}
        borderRadius="2xl"
        border="1px solid"
        borderColor={borderColor}
        p={6}
        boxShadow={`0 20px 25px -5px ${shadowColor}, 0 10px 10px -5px ${shadowColor}`}
        position="relative"
        overflow="hidden"
        maxW="md"
      >
        {/* Gradient accent */}
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          height="6px"
          bg="linear-gradient(90deg, #EF4444, #DC2626)"
        />
        
        <ModalBody p={0}>
          <VStack spacing={6} align="center" pt={4}>
            <Box 
              boxSize="60px"
              borderRadius="full"
              bg="linear-gradient(135deg, #EF4444, #DC2626)"
              display="flex"
              alignItems="center"
              justifyContent="center"
              color="white"
              fontSize="2xl"
            >
              ⚠️
            </Box>
            
            <VStack spacing={3} textAlign="center">
              <Heading 
                size="lg" 
                color={textColor}
                bgGradient="linear(to-r, #EF4444, #DC2626)"
                bgClip="text"
              >
                Підтвердження
              </Heading>
              <Text color={subtleTextColor} fontSize="md">
                {message}
              </Text>
            </VStack>
            
            <HStack spacing={4} w="full" justify="center" pt={2}>
              <Button
                onClick={onClose}
                bg={cardBg}
                border="1px solid"
                borderColor={borderColor}
                color={textColor}
                borderRadius="xl"
                px={8}
                size="lg"
                _hover={{
                  bg: hoverBg,
                  transform: "translateY(-1px)",
                }}
              >
                Скасувати
              </Button>
              <Button
                onClick={onConfirm}
                bg="linear-gradient(135deg, #EF4444, #DC2626)"
                color="white"
                borderRadius="xl"
                px={8}
                size="lg"
                boxShadow="0 4px 6px rgba(239, 68, 68, 0.3)"
                _hover={{
                  bg: "linear-gradient(135deg, #E33E3E, #C51E1E)",
                  transform: "translateY(-1px)",
                  boxShadow: "0 6px 15px rgba(239, 68, 68, 0.4)",
                }}
              >
                Видалити
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
